import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/config/seoHead";
import { directoryListLoader } from "@/hooks/useScrapedPage";

const ElnatLista = lazy(() => import("@/pages/content/ElnatLista"));

export const Route = createFileRoute("/elnat/")({
  // Hela A–Ö-listan hämtas på servern så att alla bolagssidor länkas med
  // vanliga <a href> i serverns HTML (tidigare fylldes listan i webbläsaren).
  loader: ({ context }) => directoryListLoader(context.queryClient, "elnat"),
  head: () => seoHead("/elnat", { description: "Hitta information om Sveriges elnätsbolag och deras nätområden, avgifter och villkor." }),
  component: ElnatListaRoute,
});

function ElnatListaRoute() {
  const { items } = Route.useLoaderData();
  return <ElnatLista initialItems={items} />;
}
